import { handlers } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;

async function getAll(accountID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/shifts?accountID=${accountID}`
      }))
  );
}

async function getById(shiftID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/shifts/${shiftID}`
      }))
  );
}

async function create(shift) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'POST',
        url: '/shifts',
        body: JSON.stringify(shift)
      }))
  );
}

async function update(shift) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'PUT',
        url: `/shifts/${shift.shiftID}`,
        body: JSON.stringify(shift)
      }))
  );
}

// prefixed function name with underscore because delete is a reserved word in javascript
async function Delete(shiftID) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'DELETE',
        url: `/shifts/${shiftID}`
      }))
  );
}

const shiftService = {
  getAll,
  getById,
  create,
  update,
  delete: Delete
};

export default shiftService;
